import { render, staticRenderFns } from "./OnboardingProgressBar.vue?vue&type=template&id=5e52f047"
import script from "./OnboardingProgressBar.vue?vue&type=script&lang=js"
export * from "./OnboardingProgressBar.vue?vue&type=script&lang=js"
import style0 from "./OnboardingProgressBar.vue?vue&type=style&index=0&id=5e52f047&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports